import React, {FC} from 'react';
import {CTAButton} from '../cta-button/cta-button.component';
import {Modal} from '../modal/modal.component';
import {ReactComponent as UpdateIntervalIcon} from '../../assets/updateTime.svg';

type Props = {
  onAcknowledged(): void;
};

export const UpdateIntervalModal: FC<Props> = ({onAcknowledged}) => {
  return (
    <Modal>
      <div className="flex flex-col items-center justify-center px-5">
        <div className="mb-5">
          <UpdateIntervalIcon height={100} />
        </div>
        <p className="text-black whitespace-normal text-center mb-5">Please note: Update Time will be changed after the next update completes.</p>
        <CTAButton label="Back to Update Complete" onPress={onAcknowledged} />
      </div>
    </Modal>
  );
};
